export default "__VITE_ASSET__CaombAi$__"